import React, { Component } from 'react';
import OtpField from '../../UI/otpField/otpField';
import OtpTimer from '../../UI/OtpTimer/OtpTimer';
import { errorCode, errorMsg } from '../../../ErrorCode/ErrorCode';
import mixpanelService from '../../Services/mixpanelService';
import mixpanelEvents, { getScreenName } from '../../../config/mixpanelEvents';
import './RegOtp.scss'

interface IRegOtpProps {
    label: string;
    otpTimer: number;
    eleId: string;
    onChange: (value: string) => string | void;
    resendClicked: () => string | void;
    disableOtp?: boolean;
    invalidOtp?: boolean;
}

class RegOtp extends Component<IRegOtpProps> {
    // The countdown itself lives in the shared OtpTimer (timestamp-based ring);
    // it reports completion so "Resend now" appears after otpTimer seconds.
    state = {
        otp: '',
        isResend: false,
        timerRun: 0
    };

    onTimerComplete = () => {
        this.setState({ isResend: true });
    };

    setOtp = (value: any) => {
        this.setState({ otp: value });
        this.props.onChange(value);
    };

    resendClicked = () => {
        try {
            const screen_name = getScreenName(window.location.pathname);
            if (screen_name) {
                mixpanelService({
                    event: mixpanelEvents.CTA_CLICKED,
                    screen_name,
                    text: "Resend now",
                    cta_type: "sticky",
                    cta_class: "secondary",
                    cta_service: "AOJ",
                });
            }
        } catch (e) {
            console.error("mixpanel cta_clicked failed", e);
        }

        // Restart the countdown (fresh OtpTimer run) and request a new OTP.
        this.setState((prev: any) => ({ isResend: false, timerRun: prev.timerRun + 1 }));
        this.props.resendClicked();
    };

    render() {
        const otpLabelId = `${this.props.eleId}-otp-label`;
        const otpErrorId = `${this.props.eleId}-otp-error`;
        return (
            <div className='regOtp'>
                <p className='otpLbl' id={otpLabelId}>{this.props.label}</p>

                <div className='otpInput'>
                    <OtpField
                        onChange={(value) => this.setOtp(value)}
                        eleId={this.props.eleId}
                        disableOtp={this.props.disableOtp}
                        invalidOtp={this.props.invalidOtp}
                        ariaLabelledBy={otpLabelId}
                        ariaDescribedBy={this.props.invalidOtp ? otpErrorId : undefined}
                    />

                    {this.props.invalidOtp && (
                        <p className='incrtOtp' id={otpErrorId} role="alert" aria-live="assertive">
                            {errorMsg(errorCode.FE05)}
                        </p>
                    )}
                </div>

                {this.state.isResend ? (
                    <div className='resendOtpText'>
                        <span className='otpNotRecv' id={`${this.props.eleId}-otp-resend-desc`}>Didn't receive the OTP?</span>
                        <button type='button' className='resendOtpLink' onClick={this.resendClicked} aria-describedby={`${this.props.eleId}-otp-resend-desc`}>
                            Resend now
                        </button>
                    </div>
                ) : (
                    <div className='otpTimer'>
                        <OtpTimer
                            timer={this.props.otpTimer}
                            resetKey={this.state.timerRun}
                            onComplete={this.onTimerComplete}
                        />
                    </div>
                )}
                {/* announce once when the countdown ends, not every second */}
                <p className='sr-only' role='status' aria-live='polite'>
                    {this.state.isResend ? 'You can now resend the OTP.' : ''}
                </p>
            </div>
        );
    }
}

export default RegOtp